import { render } from "./App.vue?vue&type=template&id=5777aab8&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5777aab8&lang=scss&scoped=true"

import exportComponent from "/Users/mosesadebayo/webprojects/askasoon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5777aab8"]])

export default __exports__